import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import * as React from 'react';
import HalfYearHeader from '../QuarterPanel/QuarterHeader';
import HalfYearBody from './HalfYearBody';
import { createKeyDownHandler } from '../../utils/uiUtil';

function HalfYearPanel(props) {
  var prefixCls = props.prefixCls,
      operationRef = props.operationRef,
      onViewDateChange = props.onViewDateChange,
      generateConfig = props.generateConfig,
      value = props.value,
      viewDate = props.viewDate,
      onPanelChange = props.onPanelChange,
      _onSelect = props.onSelect,
      sourceMode = props.sourceMode,
      diffValue = props.diffValue,
      headerSelect = props.headerSelect,
      showSelectMask = props.showSelectMask;
  var panelPrefixCls = "".concat(prefixCls, "-halfYear-panel"); // ======================= Keyboard =======================

  operationRef.current = {
    onKeyDown: function onKeyDown(event) {
      return createKeyDownHandler(event, {
        onLeftRight: function onLeftRight(diff) {
          _onSelect(generateConfig.addMonth(value || viewDate, diff * 6), 'key');
        },
        onCtrlLeftRight: function onCtrlLeftRight(diff) {
          _onSelect(generateConfig.addYear(value || viewDate, diff), 'key');
        },
        onUpDown: function onUpDown(diff) {
          _onSelect(generateConfig.addYear(value || viewDate, diff), 'key');
        }
      });
    }
  }; // ==================== View Operation ====================

  var onYearChange = function onYearChange(diff) {
    var newDate = generateConfig.addYear(viewDate, diff);
    onViewDateChange(newDate);
    onPanelChange(null, newDate, 'year', diff);
  };

  var _React$useState = React.useState(sourceMode),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      sourceModeCopy = _React$useState2[0],
      setSourceModeCopy = _React$useState2[1];

  React.useEffect(function () {
    if (sourceMode && sourceMode === 'year') {
      setSourceModeCopy('decade1');
    }
  }, [sourceMode]);
  React.useEffect(function () {
    if (diffValue) {
      onYearChange(diffValue[0]);
    }
  }, [diffValue]);
  return (
    /*#__PURE__*/

    /* HalfYearHeader is the same with QuarterHeader */
    React.createElement("div", {
      className: panelPrefixCls
    }, /*#__PURE__*/React.createElement(HalfYearHeader, _extends({}, props, {
      prefixCls: prefixCls,
      onPrevYear: function onPrevYear() {
        onYearChange(-1);
      },
      onNextYear: function onNextYear() {
        onYearChange(1);
      },
      onYearClick: function onYearClick() {
        onPanelChange('year', viewDate);
      },
      sourceModeCopy: sourceModeCopy
    })), /*#__PURE__*/React.createElement(HalfYearBody, _extends({}, props, {
      prefixCls: prefixCls,
      onSelect: function onSelect(date) {
        _onSelect(date, 'mouse');
      }
    })), headerSelect != undefined && showSelectMask ? /*#__PURE__*/React.createElement("div", {
      style: {
        opacity: '0.5',
        width: '100%',
        height: '100%',
        background: '#fff',
        position: 'absolute',
        left: 0,
        zIndex: '100'
      }
    }) : null)
  );
}

export default HalfYearPanel;